import React from 'react';
import "../../Css/Home/HomeAbout.css";
import { Link } from 'react-router-dom';
import image01 from '../../Images/banner/about01.jpg';
import image02 from '../../Images/banner/about02.jpg';
const HomeAbout = () => {
    return (
        <div>
            <section className='home-about-section'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-7'>
                            <div className='home-about-section-images-main-con'>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='home-about-section-image-first-con'>
                                            <div className='home-about-section-image-first-main-con'>
                                                <img src={image01} />
                                                <div class="bgeffect"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='home-about-section-image-second-con'>
                                            <div className='home-about-section-image-second-main-con'>
                                                <img src={image02} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-5'>
                            <div className='home-about-section-details-con'>
                                <div className='home-about-section-details-main-con'>
                                    <h3 className='ttcmsabout-title'>About Woodsy</h3>
                                    <p className='ttcmsabout-desc'>At Woodsy, we don’t just offer timber; we offer timeless character and natural distinction. With decades of experience and a passion for sustainable forestry, Woodsy delivers premium hardwoods, veneers, and lumber products sourced from responsibly managed forests across the globe.</p>
                                    <p className='ttcmsabout-desc'>We pride ourselves on being more than just a supplier; we are your timber solutions partner. Whether it’s for architecture, interiors, or fine furniture, Woodsy provides unmatched quality, service, and reliability.</p>

                                    <div className='ttcmsabout-btn'>
                                        <Link to="/product">
                                            Shop Now
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </section>
        </div>
    )
}

export default HomeAbout
